import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { H2, Section } from '../ui/Section';
import { CtaButton } from '../ui/CtaButton';
import { afterItems, beforeItems } from '../../data/content';
export function BeforeAfterSection() {
  return <Section tone="light" data-id="element-23" data-mp="3ahk4fnamxmvl">
      <H2 className="mx-auto max-w-3xl text-center" data-id="element-24" data-mp="3feahe1r582cs">What Changes When You Have a Structured Clinical Roadmap?</H2>

      <div className="mt-10 grid gap-6 lg:grid-cols-2" data-id="element-25" data-mp="6y7cu4vbutso">
        <div className="overflow-hidden rounded-3xl bg-white ring-2 ring-danger/40" data-id="element-26" data-mp="70tqmm8ta5jc">
          <div className="bg-danger px-6 py-5 text-white" data-id="element-27" data-mp="bx229pnsvglr">
            <p className="font-display text-sm font-bold uppercase tracking-widest text-white/85" data-id="element-28" data-mp="3tf3dus1097ij">Before</p>
            <h3 className="font-display text-2xl font-extrabold leading-tight" data-id="element-29" data-mp="26z0azypasba">Disconnected Implant Planning</h3>
          </div>
          <ul className="space-y-4 p-6" data-id="element-30" data-mp="pwa46qbcl2tn">
            {beforeItems.map(item => <li key={item} className="flex gap-3 text-base leading-snug text-ink/85" data-id="element-31" data-mp="up36l7jcfz2k">
                <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-danger/10" data-id="element-32" data-mp="22p5rpl3sb09r">
                  <XIcon className="h-4 w-4 text-danger" strokeWidth={3} aria-hidden="true" data-id="element-33" data-mp="1xqkqbicsqajq" />
                </span>
                {item}
              </li>)}
          </ul>
        </div>

        <div className="overflow-hidden rounded-3xl bg-white ring-2 ring-cta/50" data-id="element-34" data-mp="27lmf2d35tals">
          <div className="bg-cta px-6 py-5 text-white" data-id="element-35" data-mp="2ldascjp5a54c">
            <p className="font-display text-sm font-bold uppercase tracking-widest text-white/90" data-id="element-36" data-mp="2gfrg1pc0c2f1">After</p>
            <h3 className="font-display text-2xl font-extrabold leading-tight" data-id="element-37" data-mp="2vci8tfr6efvo">With Dental Implant Clinical Roadmap™</h3>
          </div>
          <ul className="space-y-4 p-6" data-id="element-38" data-mp="2qf04k2o3sou0">
            {afterItems.map(item => <li key={item} className="flex gap-3 text-base font-medium leading-snug text-ink" data-id="element-39" data-mp="10zsbeo1lmojj">
                <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-cta" data-id="element-40" data-mp="w0fm7wn995ds">
                  <CheckIcon className="h-4 w-4 text-white" strokeWidth={3} aria-hidden="true" data-id="element-41" data-mp="1lp4n6ku95sac" />
                </span>
                {item}
              </li>)}
          </ul>
        </div>
      </div>

      <p className="mx-auto mt-10 max-w-2xl text-center text-xl font-bold leading-snug" data-id="element-42" data-mp="1umwv33xn9xnp">
        Instead of keeping every consideration in your head, you have a structured place to organize it.
      </p>

      <div className="mt-10" data-id="element-43" data-mp="24mfar86iux9y">
        <CtaButton label="I want to plan with greater clarity" note="One-Time Payment · 7-Day Guarantee" data-id="element-44" data-mp="28o96r35rvd3s" />
      </div>
    </Section>;
}